/**
 * Sticky / transparent header behavior
 */
(function () {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const settings = window.themeSettings || {};
  let lastScroll = 0;

  function onScroll() {
    const scrollY = window.scrollY;

    if (settings.transparentHeader && header.classList.contains('is-transparent')) {
      header.classList.toggle('is-scrolled', scrollY > 50);
    }

    lastScroll = scrollY;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Mobile menu
  const menuDrawer = document.getElementById('MenuDrawer');
  const menuOpen = document.querySelector('[data-menu-open]');

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    window.Alverio.trapFocus(drawer.querySelector('.drawer__panel'));
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  menuOpen?.addEventListener('click', () => openDrawer(menuDrawer));

  document.querySelectorAll('[data-drawer-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      closeDrawer(btn.closest('.drawer'));
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
    }
  });
})();
